import { createSlice } from '@reduxjs/toolkit';

export const additionalResearchSlice = createSlice({
    name: 'additionalResearch',
    initialState: {
        coverPdfPath:'',
        coverConfirmedPdfPath:'',
        pdfPath:'',
    },
    reducers:{
        setAdditionalResearchCoverPdf: (state, action) => {
            state.coverPdfPath = action.payload;
        },
        setAdditionalResearchCoverConfirmedPdf: (state, action) => {
            state.coverConfirmedPdfPath = action.payload;
        },
        setAdditionalResearchPdf: (state, action) => {
            state.pdfPath = action.payload;
        }
    }
});

export const {
    setAdditionalResearchCoverPdf,
    setAdditionalResearchCoverConfirmedPdf,
    setAdditionalResearchPdf
} = additionalResearchSlice.actions;
export default additionalResearchSlice.reducer;